import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

import { Icon } from './Icon';
import { cn } from './cn';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer size-4 shrink-0 rounded border border-border-secondary text-text-primary ring-offset-bg-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-accent-quaternary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-text-primary data-[state=checked]:bg-text-primary data-[state=checked]:text-bg-tertiary',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('-mt-px flex items-center justify-center')}
    >
      <Icon
        name={props.checked === 'indeterminate' ? 'Minus' : 'Check'}
        size="xs"
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
